import { NgModule } from "@angular/core";
import { CustomGridFilterComponent } from "../components/custom-grid-filter/custom-grid-filter.component";
import { LoginComponent } from "../components/login/login.component";
import { CommonPackageModule } from "../../../module/common-package.module";
import { KendoPackageModule } from "../../core/modules/kendo.module";
import { ContentPopupComponent } from "../components/content-popup/content-popup.component";
import { AdvanceFilterComponent } from "../components/advance-filter/advance-filter.component";
import { LoaderComponent } from "../components/loader/loader.component";
import { CustomNotificationComponent } from "../components/custom-notification/custom-notification.component";
import { CustomPagerComponent } from "../components/custom-pager/custom-pager.component";
import { MultiSelectComponent } from "../components/multi-select/multi-select.component";

@NgModule({
    declarations: [LoginComponent, CustomGridFilterComponent, ContentPopupComponent, CustomPagerComponent,AdvanceFilterComponent, LoaderComponent, CustomNotificationComponent, MultiSelectComponent],
    imports: [CommonPackageModule, KendoPackageModule],
    exports: [LoginComponent, CustomGridFilterComponent, ContentPopupComponent,CustomPagerComponent, AdvanceFilterComponent, LoaderComponent, CustomNotificationComponent, MultiSelectComponent],
})
export class CommonCustomFeatureModule { }